import { ReactElement, RefObject, useEffect } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton } from '@mui/material';

import { useDialog } from '@components/atoms/dialog';
import theme from 'src/theme';

export type InteractiveContentModalProps = {
  open?: boolean;
  children: ReactElement;
  onClose?: () => void;
  containerRef: RefObject<HTMLElement | undefined>;
};

const InteractiveContentModal = ({ open, children, containerRef, onClose }: InteractiveContentModalProps) => {
  /**
   * TODO: should recheck useDialog props passing
   */
  const dialog = useDialog({
    dialogProps: {
      sx: {
        position: 'absolute',
        zIndex: 100,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      },
      container: containerRef.current,
      BackdropProps: { sx: { position: 'absolute' } },
      classes: undefined,
      disablePortal: true,
    },
    disabledBackDropClick: true,
    fullWidth: true,
    maxWidth: 'xl',
    paperStyle: {
      height: '100%',
      borderRadius: '20px',
      margin: 0,
      [theme.breakpoints.down('md')]: {
        width: '100%',
        maxHeight: '100%',
        borderRadius: 0,
      },
    },
    onClose,
  });

  useEffect(() => {
    if (open) {
      dialog.open();
    } else {
      dialog.close();
    }
  }, [dialog.open, dialog.close, open]);

  return dialog.render(
    <>
      {children}
      <Box
        sx={{
          position: 'absolute',
          top: 10,
          right: 10,
        }}
      >
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
    </>,
  );
};

export default InteractiveContentModal;
